module.exports = __webpack_public_path__ + "img/entry-image-xs-pl.78c67647.png";